import { validate as uuidValidate } from 'uuid';
import axios from 'axios';

import authHeader from './auth-header';


// const URL_V2_API = 'https://api.squaregolf.com/v2/coupon';
const URL_V3_API = 'https://api.squaregolf.com/v3/coupon';

class _CouponService {
  getRegisteredCoupons() {
    return axios.get(URL_V3_API, { 
      headers: authHeader() 
    });
  }

  registerCoupon(tagetId: string, couponId: string) {
    if (uuidValidate(tagetId)) {
      // return axios.post(URL_V2_API + '/register', {
      //   userUuid: tagetId,
      //   couponSerialNumber: couponId,
      // }, { 
      //   headers: authHeader(),
      // });
      return axios.post(URL_V3_API + '/register', {
        userUuid: tagetId,
        serialNumber: couponId,
      }, { 
        headers: authHeader(),
      })
      .then((res) => {
        return res;
      });
    } else {
      // return axios.post(URL_V2_API + '/register', {
      //   username: tagetId,
      //   couponSerialNumber: couponId,
      // }, { 
      //   headers: authHeader(),
      // });
      return axios.post(URL_V3_API + '/register', {
        username: tagetId,
        serialNumber: couponId,
      }, { 
        headers: authHeader(),
      })
      .then((res) => {
        return res;
      });
    }
  }
}


const CouponService = new _CouponService();
export default CouponService;